module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon8.b544c1f8.png";